import React from "react";
import html2pdf from "html2pdf.js";

const PrivacyPolicy = () => {
  const downloadPDF = () => {
    const element = document.getElementById("content");
    const opt = {
      margin: 10,
      filename: "QMentisAI-Privacy-Policy.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };
    html2pdf().set(opt).from(element).save();
  };

  return (
    <div style={styles.container}>
      {/* Download Button */}
      <div style={{ textAlign: "right", marginBottom: "20px" }}>
        <button id="downloadBtn" style={styles.downloadBtn} onClick={downloadPDF}>
          ⬇ Download PDF
        </button>
      </div>

      {/* Content */}
      <div id="content">
        <h1 style={styles.h1}>Privacy Policy</h1>
        <p style={styles.meta}>
          This Privacy Policy explains how QualiZeal processes personal data in connection with QMentisAI.
        </p>

        <h2 style={styles.h2}>Who We Are</h2>
        <p>
          QMentisAI is an AI-driven quality engineering platform operated by QualiZeal Inc. and its affiliates. Contact:{" "}
          <a href="mailto:aithinktank@qualizeal.com">aithinktank@qualizeal.com</a>
        </p>

        <h2 style={styles.h2}>Scope</h2>
        <p>
          This Policy covers personal data processed through QMentisAI interfaces, admin portals, and integrations;
          separate contractual terms may apply for enterprise deployments. It does not address third-party
          sites/services linked from the Application.
        </p>

        <h2 style={styles.h2}>Categories of Personal Data</h2>
        <ul>
          <li><strong>Account data:</strong> name, business email, role, organization, authentication identifiers.</li>
          <li><strong>Telemetry/usage:</strong> logs, device/browser metadata, IP, time stamps, feature usage, and events for security and product improvement.</li>
          <li><strong>Business content:</strong> prompts, requirements, test artifacts, defect data, and related metadata provided by users; avoid uploading special-category data unless necessary and lawful.</li>
          <li><strong>Support communications:</strong> tickets, feedback, and incident details.</li>
        </ul>

        <h2 style={styles.h2}>Lawful Bases and Purposes</h2>
        <p>
          Processing is based on consent, performance of a contract, legitimate interests in securing and improving
          services, and compliance with legal obligations, as applicable. Purposes include authentication, service
          delivery, security monitoring, usage analytics, feature improvement, support, billing, and compliance.
        </p>

        <h2 style={styles.h2}>Collection Methods</h2>
        <p>
          Data is collected directly from users, from enterprise administrators, and automatically via cookies/SDKs and
          logs; some integrations may supply data from third-party systems under user or enterprise authorization.
        </p>

        <h2 style={styles.h2}>Cookies and Similar Technologies</h2>
        <p>
          We use necessary, functional, analytics, and security cookies; controls are available via browser settings and
          in-product preferences, subject to functionality impacts.
        </p>

        <h2 style={styles.h2}>Retention</h2>
        <p>
          Data is retained only as long as necessary for the purposes stated or as required by law; upon expiry, data is
          securely deleted or anonymized, with enterprise data handling governed by contract.
        </p>

        <h2 style={styles.h2}>Security</h2>
        <p>
          We employ reasonable technical and organizational measures (access controls, encryption in transit, logging,
          and vulnerability management) and continuously enhance controls in line with threat landscape and regulatory
          expectations.
        </p>

        <h2 style={styles.h2}>Sharing and Disclosures</h2>
        <ul>
          <li><strong>Service providers:</strong> cloud hosting, security monitoring, analytics, and support vendors under confidentiality and data processing terms.</li>
          <li><strong>Legal compliance:</strong> disclosures required by law or to protect rights, safety, and systems.</li>
          <li><strong>Corporate events:</strong> transfers in mergers, acquisitions, or restructuring with continuity of protections.</li>
        </ul>

        <h2 style={styles.h2}>International Transfers</h2>
        <p>
          Where transfers occur, we implement appropriate safeguards and comply with DPDP restrictions and any government
          whitelists/blacklists guidance as finalized.
        </p>

        <h2 style={styles.h2}>Children’s Data</h2>
        <p>QMentisAI is not directed to children under 18; we do not knowingly collect children’s personal data.</p>

        <h2 style={styles.h2}>User Choices and Rights</h2>
        <ul>
          <li>Access/correction/erasure requests via in-product controls or privacy contacts; enterprise users may need to route requests through their administrators.</li>
          <li>Consent withdrawal and opt-outs for specific processing and marketing communications.</li>
        </ul>

        <h2 style={styles.h2}>AI Transparency</h2>
        <p>
          QMentisAI uses LLMs, RAG, and agentic workflows to generate outputs; outputs may be probabilistic and require
          human review, testing, and policy/compliance checks before use in production contexts.
        </p>

        <h2 style={styles.h2}>Data Breach Response</h2>
        <p>
          We maintain incident response procedures, notify applicable authorities and affected individuals where
          required, and provide remediation guidance.
        </p>

        <h2 style={styles.h2}>Changes to This Policy</h2>
        <p>
          We may update this Policy; material changes will be communicated within the Application or via email, with
          effective dates indicated.
        </p>

        <h2 style={styles.h2}>Contact</h2>
        <p>
          Email: <a href="mailto:aithinktank@qualizeal.com">aithinktank@qualizeal.com</a> for privacy or product
          questions.
        </p>
        <p>For enterprise contracts, use the designated account and security contacts provided in the agreement.</p>

        <hr />
        <p style={styles.footer}>© QualiZeal Inc. All rights reserved.</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, Helvetica, sans-serif",
    maxWidth: "860px",
    margin: "40px auto",
    lineHeight: "1.6",
    padding: "0 16px",
  },
  h1: { fontSize: "1.9rem", marginBottom: "0.5rem", lineHeight: 1.25 },
  h2: { fontSize: "1.25rem", marginTop: "1.5rem", lineHeight: 1.25 },
  meta: { color: "#555", fontSize: "0.95rem", marginBottom: "1.2rem" },
  footer: { marginTop: "2rem", fontSize: "0.95rem", color: "#444" },
  downloadBtn: {
    backgroundColor: "#49A3FF",
    color: "white",
    border: "none",
    padding: "10px 18px",
    fontSize: "14px",
    borderRadius: "8px",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    transition: "background-color 0.3s ease, transform 0.2s ease",
  },
};

export default PrivacyPolicy;
